import { GridViewColumn } from 'pf9-ui-components/built/elements/grid/Grid'
import { pick } from 'ramda'
import React, { useState } from 'react'
import { listTablePrefs } from 'app/constants'
import CreateButton from 'core/components/buttons/CreateButton'
import ListContainer from 'core/containers/ListContainer'
import { GridRowMenuItemSpec } from 'core/elements/grid/hooks/useGridRowMenu'
import { GridBatchActionSpec } from 'core/elements/grid/hooks/useGridSelectableRows'
import useGlobalParams from 'core/hooks/useGlobalParams'
import { createUsePrefParamsHook } from 'core/hooks/useParams'
import DataKeys from 'k8s/DataKeys'
import DatabaseClusterDeploymentModalForm from './deployment-form/DatabaseClusterDeploymentModalForm'

const MOCK_DATA = [
  {
    id: 'cluster-1',
    name: 'db-pg-479.acme.com',
    dbEngine: 'PostgreSQL v15.7',
    responding: 'Healthy',
    connection: '',
  },
]

const searchTargets = ['name', 'id']
const defaultParams = {
  orderBy: 'created',
  orderDirection: 'desc',
}
const usePrefParams = createUsePrefParamsHook('DatabaseClustersListTable', listTablePrefs)

interface DatabaseClusters {
  id: string
  name: string
  dbEngine: string
  responding: string
  connection: string
}

type ModelDataKey = DataKeys.DatabaseClusters
type SelectorModel = DatabaseClusters

const columns: GridViewColumn<SelectorModel>[] = [
  { key: 'name', label: 'Cluster Name' },
  { key: 'dbEngine', label: 'DB Engine' },
  { key: 'responding', label: 'Responding' },
  { key: 'connection', label: 'Connection Info' },
]

export default function DatabaseClustersListTable() {
  const {
    allParams: params,
    updateGlobalParams,
    getParamsUpdater,
  } = useGlobalParams(usePrefParams, defaultParams)
  const [showCreateClusterForm, setShowCreateClusterForm] = useState(false)

  const batchActions: GridBatchActionSpec<SelectorModel>[] = [
    {
      label: 'Backup',
      icon: 'edit',
      handleAction: ([cluster]) => {
        console.log(cluster)
      },
      refreshAfterSuccess: true,
    },
    {
      label: 'Restore',
      icon: 'tags',
      handleAction: ([cluster]) => {
        console.log(cluster)
      },
      refreshAfterSuccess: true,
    },
    {
      label: 'Upgrade',
      icon: 'tags',
      handleAction: ([cluster]) => {
        console.log(cluster)
      },
      refreshAfterSuccess: true,
    },
  ]

  const rowMenuItems: Array<GridRowMenuItemSpec<SelectorModel>> = [
    {
      label: 'Edit',
      icon: 'edit',
      handleClick: (cluster) => {},
    },
    {
      label: 'Monitor',
      icon: 'monitor-waveform',
      handleClick: (cluster) => {},
    },
  ]

  return (
    <>
      {showCreateClusterForm && (
        <DatabaseClusterDeploymentModalForm onClose={() => setShowCreateClusterForm(false)} />
      )}
      <ListContainer<ModelDataKey, SelectorModel>
        dataKey={DataKeys.DatabaseClusters}
        searchTargets={searchTargets}
        uniqueIdentifier="id"
        data={MOCK_DATA}
        columns={columns}
        getParamsUpdater={getParamsUpdater}
        extraHeaderContent={
          <CreateButton onClick={() => setShowCreateClusterForm(true)}>
            Deploy New DB Cluster
          </CreateButton>
        }
        onRefresh={() => console.log('refresh')}
        batchActions={batchActions}
        rowMenuItems={rowMenuItems}
        multiSelection
        isReadOnly={false}
        {...pick(listTablePrefs, params)}
      />
    </>
  )
}
